import styled from "styled-components";
import ChargeListTable from "./chargeListTable";
import { text } from "stream/consumers";
import CellComponent from "./cellComponent";
import { formatDate } from "../../types/types";

const Container = styled.div`
  width: 90vw;
  height: 127vw;
  align-items: center;
  background-color: white;
`;

const Wrapper2 = styled.div`
  width: 87vw;
  height: 127vw;
  margin: 0 auto;
  color: #000;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 10vw;
  margin-top: 2vw;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;

  img {
    width: 23vw;
    height: auto;
  }

  h1 {
    font-size: 2.5vw;
    color: #ff4500;
    margin-left: 1vw;
  }
`;
const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
`;
const Date = styled.div`
  font-size: 1.5vw;
  font-weight: 300;
`;

const ChargeTitleContainer = styled.div`
  width: 34vw;
  display: flex;
  justify-content: end;
`;

const ChargeTitle = styled.div`
  font-size: 4vw;
  font-weight: 700;
  margin-bottom: 1vw;
  text-align: end;
`;

const ChargeTitle2 = styled.div`
  min-width: 3vw;
  font-size: 4vw;
  font-weight: 700;
  margin-bottom: 1vw;
  text-align: end;
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 87vw;
  height: 110vw;
`;

const HeaderArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 3vw;
  /* border: 0.1vw solid black; */
`;

const ContentsArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vw;
  /* background-color: aliceblue; */
  margin-top: 0.2vw;
`;

const ChargeContentsArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 87vw;
  /* background-color: #e0e0e0; */
`;

const SumContentsArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const LeftSideArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3.8vw;
  height: 100%;
  border: 0.1vw solid #606060;
  border-bottom: none;
  background-color: #f4f4f4;
  font-size: 1.8vw;
  font-weight: 600;
  padding: 1vw;
  line-height: 3vw;
`;

const RightSideArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  width: 100%;
  height: 100%;
`;

const HeaderItem = styled.div<{
  width?: string;
  $isLast?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.6vw;
  font-weight: 600;
  width: ${(props) => props.width};
  height: 100%;
  border-top: 0.1vw solid #606060;
  border-bottom: 0.1vw solid #606060;
  border-left: 0.1vw solid #606060;
  border-right: ${(props) => (props.$isLast ? "0.1vw solid #606060;" : "")};
  background-color: #f4f4f4;
`;

const SumInputRow = styled.div<{
  height?: string;
}>`
  display: flex;
  justify-content: start;
  align-items: center;
  width: 100%;
  height: ${(props) => (props.height ? props.height : "3vw")};
`;

const SumNameArea = styled.div<{
  width?: string;
  height?: string;
  $isLast?: boolean;
}>`
  display: flex;
  justify-content: start;
  align-items: center;
  width: ${(props) => (props.width ? props.width : "20vw")};
  height: 100%;
  background-color: #f4f4f4;
  border: 0.1vw solid #606060;
  border-bottom: ${(props) =>
    props.$isLast ? "0.1vw solid #606060;" : "none"};
  font-size: 1.8vw;
  font-weight: 500;
  padding-left: 1.4vw;
  letter-spacing: 0.2vw;
`;

const SumDisplayArea = styled.div<{
  width?: string;
  height?: string;
  $isLast?: boolean;
}>`
  display: flex;
  justify-content: end;
  align-items: center;
  width: ${(props) => (props.width ? props.width : "20vw")};
  height: 100%;
  border: 0.1vw solid #606060;
  border-bottom: ${(props) =>
    props.$isLast ? "0.1vw solid #606060;" : "none"};
  border-left: none;
  font-size: 1.8vw;
  font-weight: 500;
  padding-right: 0.8vw;
  letter-spacing: 0.2vw;
`;

const SumInputArea = styled.div<{
  width?: string;
  height?: string;
  $isLast?: boolean;
}>`
  display: flex;
  position: relative;
  width: ${(props) => (props.width ? props.width : "20vw")};
  height: 100%;
`;

const SumInputBox = styled.input<{
  width?: string;
  height?: string;
  $isLast?: boolean;
}>`
  display: flex;
  justify-content: end;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: red;
  border: 0.1vw solid #606060;
  border-bottom: ${(props) =>
    props.$isLast ? "0.1vw solid #606060;" : "none"};
  border-left: none;
  font-size: 1.8vw;
  font-weight: 500;
  padding-right: 0.8vw;
  letter-spacing: 0.2vw;
`;

const SumRemarkArea = styled.div<{
  width?: string;
  height?: string;
  $isLast?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props) => (props.width ? props.width : "20vw")};
  height: 100%;
  border: 0.1vw solid #606060;
  border-bottom: ${(props) =>
    props.$isLast ? "0.1vw solid #606060;" : "none"};
  border-left: none;
  font-size: 1.8vw;
  font-weight: 500;
  letter-spacing: 0.2vw;
`;

function ChargeExportSecondPage(props: any) {
  const { chargeList, currentPage, contractDate, currentId } = props;
  const data = chargeList[currentPage - 1];

  return (
    <Container className={`companyContractPage${currentId}`}>
      <Wrapper2>
        <Header>
          <Logo>
            <img src="/icon/tonginLogo.png" alt="Logo" />
          </Logo>
          <DateContainer>
            <ChargeTitleContainer>
              <ChargeTitle>산출내역서</ChargeTitle>
              <ChargeTitle2>{currentPage}</ChargeTitle2>
            </ChargeTitleContainer>
            <Date>DATE : {formatDate(contractDate)}</Date>
          </DateContainer>
        </Header>
        <Wrapper>
          <HeaderArea>
            <HeaderItem width={"24vw"}>항 목</HeaderItem>
            <HeaderItem width={"15vw"}>규 격</HeaderItem>
            <HeaderItem width={"6vw"}>단위</HeaderItem>
            <HeaderItem width={"6vw"}>수량</HeaderItem>
            <HeaderItem width={"15vw"}>단가</HeaderItem>
            <HeaderItem width={"15vw"}>금액</HeaderItem>
            <HeaderItem width={"6vw"} $isLast={true}>
              비고
            </HeaderItem>
          </HeaderArea>
          <ContentsArea>
            <ChargeContentsArea>
              <LeftSideArea>순용역원가</LeftSideArea>
              <RightSideArea>
                <ChargeListTable
                  idx={1}
                  data={data.materialCost}
                  currentPage={currentPage}
                  isExport={true}
                ></ChargeListTable>
                <ChargeListTable
                  idx={2}
                  data={data.movingCost}
                  currentPage={currentPage}
                  isExport={true}
                ></ChargeListTable>
                <ChargeListTable
                  idx={3}
                  data={data.laborCost}
                  currentPage={currentPage}
                  isExport={true}
                ></ChargeListTable>
                <ChargeListTable
                  idx={4}
                  data={data.ectCost}
                  currentPage={currentPage}
                  isExport={true}
                ></ChargeListTable>
              </RightSideArea>
            </ChargeContentsArea>
            <SumContentsArea>
              <SumInputRow>
                <SumNameArea width={`51.06vw`}>5. 합계</SumNameArea>
                <SumDisplayArea width={`30.02vw`}>{data.total}</SumDisplayArea>
                <SumRemarkArea width={`5.92vw`}></SumRemarkArea>
              </SumInputRow>
              <SumInputRow>
                <SumNameArea width={`51.1vw`}>6. 공과잡비</SumNameArea>
                {/* <CellComponent
                  width={"6vw"}
                  value={data.expensesRate}
                  name={`data.expensesRate`}
                  currentPage={currentPage}
                  idx={0}
                  type={"number"}
                  readOnly
                ></CellComponent>
                <CellComponent
                  width={"6vw"}
                  value={"%"}
                  idx={0}
                  type={"string"}
                  readOnly
                ></CellComponent> */}
                <SumDisplayArea width={`30.02vw`}>
                  {data.expenses}
                </SumDisplayArea>
                <SumRemarkArea width={`5.92vw`}></SumRemarkArea>
              </SumInputRow>
              <SumInputRow>
                <SumNameArea width={`51.06vw`}>7. 일반관리비</SumNameArea>
                <SumDisplayArea width={`30.02vw`}>
                  {data.commonCost}
                </SumDisplayArea>
                <SumRemarkArea width={`5.92vw`}></SumRemarkArea>
              </SumInputRow>
              <SumInputRow>
                <SumNameArea width={`51.1vw`}>8. 이 윤</SumNameArea>
                {/* <CellComponent
                  width={"6vw"}
                  value={data.profitRate}
                  name={`data.profitRate`}
                  currentPage={currentPage}
                  idx={0}
                  type={"number"}
                  readOnly
                ></CellComponent>
                <CellComponent
                  width={"6vw"}
                  value={"%"}
                  idx={0}
                  type={"string"}
                  readOnly
                ></CellComponent> */}
                <SumDisplayArea width={`30.02vw`}>{data.profit}</SumDisplayArea>
                <SumRemarkArea width={`5.92vw`}></SumRemarkArea>
              </SumInputRow>
              <SumInputRow>
                <SumNameArea width={`51.06vw`}>9. 총 용역원가</SumNameArea>
                <SumDisplayArea width={`30.02vw`}>
                  {data.totalServiceCost}
                </SumDisplayArea>
                <SumRemarkArea width={`5.92vw`}></SumRemarkArea>
              </SumInputRow>
              <SumInputRow height={`4vw`}>
                <SumNameArea width={`51.06vw`} $isLast>
                  10. 견적가
                </SumNameArea>
                <SumDisplayArea width={`30.02vw`} $isLast>
                  {data.quotedPrice}
                </SumDisplayArea>
                <SumRemarkArea width={`5.92vw`} $isLast></SumRemarkArea>
              </SumInputRow>
            </SumContentsArea>
          </ContentsArea>
        </Wrapper>
      </Wrapper2>
    </Container>
  );
}

export default ChargeExportSecondPage;
